<template>
  <div class="main-content paketpromo">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">Info Seputar Promo dan Paket</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="fasilitas-containter">
      <div class="container">
        <div class="section-title text-center">
          <div class="row">
            <div class="col-md-12">
              <h2 class="text-uppercase mt-0 line-height-1">
                Info Paket dan Promo
                <span class="text-theme-colored">Rumah Sakit UII</span>
              </h2>
            </div>
          </div>
        </div>
        <div class="section-content mt-30">
          <div v-if="promotions.length < 1" class="alert alert-danger">
            No data
          </div>
          <div class="row">
            <!-- START -->
            <div
              v-bind:key="item.id"
              v-for="item in promotions"
              class="col-xs-12 col-sm-12 col-md-6 col-lg-4 mb-30"
            >
              <div class="bg-uii">
                <img v-bind:src="JSON.parse(item.meta).meta_picture" alt />
                <div class="row pl-20 pr-20">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <h5 class="mt-15 mb-0">{{ item.title }}</h5>
                  </div>
                  <div
                    v-if="JSON.parse(item.meta).price != '0'"
                    class="col-lg-12 col-md-12 col-sm-12"
                  >
                    <span class="mt-5 mb-5 tarif-text text-left">
                      <strike
                        >IDR {{ JSON.parse(item.meta).price_discount }}</strike
                      >
                    </span>
                    <h5 class="mt-5 mb-5 tarif-text text-left">
                      IDR {{ JSON.parse(item.meta).price }}
                    </h5>
                  </div>
                </div>
                <div class="row p-20">
                  <div
                    class="col-lg-12 col-md-12 col-sm-12"
                    v-html="item.description"
                  ></div>
                </div>
                <div class="text-right">
                  <button
                    class="btn btn-primary text-right m-2"
                    @click="onDownloadImage(JSON.parse(item.meta).meta_picture)"
                  >
                    Unduh
                  </button>
                </div>
              </div>
            </div>
            <!-- END -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style lang="">
.bg-uii {
  border-radius: 5px;
}
</style>
<script>
import api from "../services/api";

export default {
  data() {
    return {
      show_loading: false,
      promotions: []
    };
  },
  mounted() {
    this.getPromotions();
  },
  methods: {
    async onDownloadImage(image) {
      const fileName = image;

      try {
        const response = await fetch(fileName);
        const blob = await response.blob();
        const url = await URL.createObjectURL(blob);
        const dateTime = new Date().getTime();

        const a = document.createElement("a");
        a.href = url;
        a.download = "promotion-" + dateTime + ".png";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (err) {
        console.log({ err });
      }
    },
    getPromotions() {
      this.show_loading = true;
      api
        .post(api.route.get.promotion)
        .then(res => {
          let status = res.status;
          if (status) this.promotions = res.data;
          this.show_loading = false;
        })
        .catch(err => {
          console.log(err);
          this.show_loading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/PaketPromo.vue